module.exports = new __parcel__URL__("bikeTour2.4bc8aa97.png").toString();